// InterceptorInitializer.js
import { useEffect } from "react";
import { initApiInterceptors } from "../apiInterceptor/apiInterceptor"

const InterceptorInitializer = () => {
  useEffect(() => {
    initApiInterceptors();
  }, []);

  return null; 
};

export default InterceptorInitializer;
